import { AMENITIES_DETAILS, type CommunityAmenity } from '@/domain/communities';
import type { FC } from 'react';

interface Props {
  amenity: CommunityAmenity;
}

const AmenityCard: FC<Props> = ({ amenity }) => {
  const amenityDetails = AMENITIES_DETAILS[amenity];

  return (
    <div className="bg-white p-6 rounded-none border border-gray-200 hover:border-gray-300 transition-colors duration-300">
      <div className="text-accent-600 mb-4">{amenityDetails.icon({ className: 'w-6 h-6' })}</div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2">{amenityDetails.name}</h3>
      <p className="text-gray-600">{amenityDetails.description}</p>
    </div>
  );
};

export default AmenityCard;
